'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DropdownItem = require('../../components/Dropdown/DropdownItem');

var _SimpleContactUs = require('../../components/ContactUs/SimpleContactUs');

var _SimpleContactUs2 = _interopRequireDefault(_SimpleContactUs);

var _createLoginClient = require('../../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _ClientError = require('../../helpers/ClientError');

var _PopupType = require('../../helpers/PopupType');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _Product = require('../../helpers/Product');

var _ContactUs = require('./ContactUs.scss');

var _ContactUs2 = _interopRequireDefault(_ContactUs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxContactUsChars = 500;

var ContactUs = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, log: state.log, appInfo: state.appInfo };
}, { changePopupType: _popup.changePopupType, contactUs: _auth.contactUs, editEmailMessageError: _auth.editEmailMessageError, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ContactUs, _Component);

  function ContactUs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ContactUs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactUs.__proto__ || (0, _getPrototypeOf2.default)(ContactUs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false,
      textAreaError: false,
      selectedFilter: null,
      textAreaValue: '',
      categories: null
    }, _this.onAddresses = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.Addresses));
    }, _this.onChangeSubject = function (newItem) {
      _this.setState({ selectedFilter: newItem });
    }, _this.onSend = function () {
      if (!_this.props.auth.emailErrorMessage && !_this.state.textAreaError) {
        var isEmailNotEmpty = _this.validateEmailNotEmpty();
        var isTextAreaValid = _this.validateTextArea();
        var isFormValid = isEmailNotEmpty && isTextAreaValid;
        if (isFormValid) {
          _this.setState({ loading: true });
          _this.props.contactUs(_this.state.selectedFilter.id, _this.state.textAreaValue, _this.props.appInfo.version, _this.props.log.contactUsSrc);
        }
      }
    }, _this.getContactUsCategories = function () {
      (0, _createLoginClient2.default)().then(function (loginClient) {
        return loginClient.support.getContactUsCategories({
          clientId: _this.props.auth.clientId,
          languageTag: _this.props.auth.lang }, { responseContentType: 'application/json' }).then(function (result) {
          var categories = [];
          (0, _entries2.default)(result.obj.categories).forEach(function (_ref2) {
            var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            categories.push(new _DropdownItem.DropdownItem(key, key, value));
          });
          _this.setState({ categories: categories, selectedFilter: categories[0] });
        }).catch(function (error) {
          (0, _Error.logError)(error.statusText);
        });
      }).catch(function (error) {
        (0, _ClientError.createLoginClientError)(error, new Error().stack, _this.props.pushState, _this.props.auth);
      });
    }, _this.validateEmailNotEmpty = function () {
      var value = false;
      if (_this.props.auth.email) {
        value = true;
      } else {
        _this.props.editEmailMessageError(_DefaultString.translations.InvalidEmailMessage);
      }
      return value;
    }, _this.validateTextArea = function () {
      var value = false;
      if (_this.state.textAreaValue.length > 0) {
        value = true;
      } else {
        _this.setState({ textAreaError: true });
      }
      return value;
    }, _this.handleTextChange = function (event) {
      _this.setState({ textAreaValue: event.target.value, textAreaError: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ContactUs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getContactUsCategories();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.lang !== nextProps.auth.lang) {
        this.getContactUsCategories();
      } else if (this.props.auth.sendingContactUs && !nextProps.auth.sendingContactUs) {
        if (!nextProps.auth.error) {
          this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.ContactUsFeedback));
        } else {
          this.setState({ loading: false });
          this.props.changePopupType(_PopupType.PopupId.UnknownError);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;

      var privacy = formatMessage(_DefaultString.translations.PrivacyEmail);
      var login = formatMessage(_DefaultString.translations.Addresses).toLowerCase();
      var mailToLink = 'mailto:' + privacy + '?Subject=' + encodeURIComponent(formatMessage(_DefaultString.translations.PrivacyMailToSubject));
      var textLength = this.state.textAreaValue.length;

      var isMusic = this.props.auth.productName === _Product.PRODUCT_NAMES.Music;

      if (!isMusic) {
        return _react2.default.createElement(_SimpleContactUs2.default, null);
      }

      return _react2.default.createElement(
        'div',
        { className: _ContactUs2.default.contactUs },
        _react2.default.createElement(
          'div',
          { className: _ContactUs2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ContactUsTextOnly)
        ),
        _react2.default.createElement(_components.CustomDropdown, {
          className: _ContactUs2.default.dropdown, items: this.state.categories, onItemClick: this.onChangeSubject,
          selectedItem: this.state.selectedFilter
        }),
        _react2.default.createElement(_components.EmailInput, {
          intl: this.props.intl,
          placeholder: _DefaultString.translations.EmailAddress
        }),
        _react2.default.createElement(
          'div',
          { className: _ContactUs2.default.textAreaContent + (this.state.textAreaError ? ' ' + _ContactUs2.default.error : '') },
          this.state.textAreaError ? _react2.default.createElement(
            'div',
            { className: _ContactUs2.default.errorMessage },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.RequiredField)
          ) : '',
          _react2.default.createElement('textarea', {
            className: _ContactUs2.default.textArea, value: this.state.textAreaValue, onChange: this.handleTextChange,
            maxLength: maxContactUsChars
          }),
          _react2.default.createElement(
            'div',
            { className: _ContactUs2.default.maxChars + (textLength >= maxContactUsChars ? ' ' + _ContactUs2.default.maxCharsReached : '') },
            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.ContactUsMaxChars, {
              values: { value: textLength, maxValue: maxContactUsChars }
            }))
          )
        ),
        _react2.default.createElement(_components.BaseButton, {
          className: _ContactUs2.default.button,
          buttonString: _DefaultString.translations.Send,
          onClick: this.onSend,
          isInactive: this.props.auth.emailErrorMessage || this.state.textAreaError,
          loading: this.state.loading
        }),
        _react2.default.createElement(
          'div',
          { className: _ContactUs2.default.footer },
          _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.ContactUsFooter, {
            values: {
              addresses: _react2.default.createElement(
                'span',
                { className: _ContactUs2.default.link, onClick: this.onAddresses },
                login
              ),
              privacyEmail: _react2.default.createElement(
                'a',
                { href: mailToLink, target: '_top' },
                privacy
              )
            }
          }))
        )
      );
    }
  }]);
  return ContactUs;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  contactUs: _react.PropTypes.func.isRequired,
  editEmailMessageError: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  appInfo: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ContactUs);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ContactUs/ContactUs.js
// module id = 2002
// module chunks = 0